import { RootState } from '@store';
import { createSelector } from 'reselect';
import { Account, AccountTemplate, Identifier } from '@types';
import { AccountState, account } from '@store/reducers/account.reducer';
import { selectSelectedLoanNumber } from '@store/selectors/widgets.selectors';
import { selectFeatureFlag } from '@store/reducers/config.reducer';
import { isEmpty } from 'lodash';

const accountSlice = (state: RootState) => state.account || account;
export const acpForAllStatus = (state: RootState) => selectFeatureFlag(state, 'acpForAllStatus');

export const selectAccount = createSelector([accountSlice], (slice: AccountState): Account => slice.account);

export const selectAccountData = createSelector(selectAccount, (accountData: Account): AccountTemplate[] => accountData.servicingLoans);

export const selectActiveAccount = createSelector([selectAccountData], (activeAccountData): AccountTemplate[] => {
    if (!acpForAllStatus)
        return (
            activeAccountData &&
            activeAccountData.filter(
                ele =>
                    ele.accountStatus.name === 'Current Account' ||
                    ele.accountStatus.name === 'Payment Due Now' ||
                    ele.accountStatus.name === 'Past Due'
            )
        );
    return activeAccountData || [];
});

export const selectActiveAccountInformation = createSelector(
    [selectActiveAccount, selectSelectedLoanNumber],
    (activeAccounts: AccountTemplate[], selectedIdentifier: Identifier) => {
        if (isEmpty(activeAccounts) || isEmpty(selectedIdentifier)) return undefined;
        const { identifier } = selectedIdentifier;
        return activeAccounts.find((account: AccountTemplate) => account.accountNumber === identifier);
    }
);
